import { gql } from '@apollo/client';
import { omit } from 'lodash';
import { MeasurementSystem } from 'spw-components/unit-conversion/types';
import { graphqlClient } from './utils';
import { ReportRequest } from '../models/Report';

export const exportReport = (
  reportRequest: ReportRequest,
  zipName: string,
  downloadAsZip = false
) => {
  return graphqlClient.query<{ report: { file: string; name: string } }>({
    fetchPolicy: 'no-cache',
    query: gql`
      query ExportReport($args: ReportArgs!) {
        report: exportReport(args: $args) {
          file
          name
        }
      }
    `,
    variables: {
      args: {
        projectId: reportRequest.projectId,
        benchmarkReportId: reportRequest.benchmarkReportId,
        reportEntries: reportRequest.reportEntries.map((reportEntry) => ({
          ...reportEntry,
          variants: omit(
            {
              ...reportEntry.variants,
              showClientFacingNames:
                reportEntry.variants?.shouldShowClientFacingNames,
            },
            ['shouldShowClientFacingNames']
          ),
        })),
        zipName,
        downloadAsZip,
      },
    },
  });
};

export const downloadWorksheetSpreadsheet = (params: {
  scenarioId?: number | null;
  totalProgramId?: number | null;
  rowsOpen: boolean;
  showDecimals: boolean;
  showClientFacingNames: boolean;
  measurementSystem: MeasurementSystem;
}) => {
  return graphqlClient.query<{ spreadsheet: string }>({
    fetchPolicy: 'no-cache',
    query: gql`
      query ExportWorksheetSpreadsheet(
        $scenarioId: Int
        $totalProgramId: Int
        $rowsOpen: Boolean
        $showDecimals: Boolean
        $showClientFacingNames: Boolean
        $measurementSystem: String
      ) {
        spreadsheet: exportWorksheetSpreadsheet(
          scenarioId: $scenarioId
          totalProgramId: $totalProgramId
          rowsOpen: $rowsOpen
          showDecimals: $showDecimals
          showClientFacingNames: $showClientFacingNames
          measurementSystem: $measurementSystem
        )
      }
    `,
    variables: params,
  });
};
